import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web'
import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class MyMonitoringService {
  static readonly IgnoredErrorMessages = [
    'Error invoking postMessage: Java object is gone'
  ];

  appInsights: ApplicationInsights;
  
  constructor(private http: HttpClient) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: '',
        enableAutoRouteTracking: true
      }
    });

    this.http.get<{ instrumentationKey: string }>(`${environment.apiUrl}config/appinsights-key`)
      .subscribe({
        next: (response) => {
          if (response?.instrumentationKey) {
            this.appInsights.config.instrumentationKey = response.instrumentationKey;
          }
          this.appInsights.loadAppInsights();
          this.appInsights.addTelemetryInitializer((envelope: ITelemetryItem) => {
            if (envelope.baseType === 'ExceptionData') {
              const exceptions: Array<{ message?: string }> = envelope.baseData?.['exceptions'] ?? [];
              if (exceptions.some(ex => MyMonitoringService.IgnoredErrorMessages.some(msg => ex.message?.includes(msg)))) {
                return false;
              }
            }
            return true;
          });
        },
        error: (error) => {
          console.error('Failed to load Application Insights configuration:', error);
          this.appInsights.loadAppInsights();
        }
      });
  }

  logPageView(name?: string, url?: string) { // option to call manually
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: name}, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message}, properties);
  }
}
